module.exports = __webpack_public_path__ + "static/media/15.3e6088e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/pants/15.png
// module id = 1388
// module chunks = 0